import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, RowSelectEventArgs, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { UnidadFuncionalService, TipoUnidadService, ComunidadService,ConsorcioService, TenantService } from '../../../../../src/app/shared/services';
import { Comunidad, GridPageSettings, SearchComunidadRequest, Consorcio, SearchConsorcioRequest, LocalStorageKeys, TenantFeatureFlags } from '../../../../../src/app/shared/model';
import { SearchTipoUnidadRequest, TipoUnidad, UnidadFuncional, DialogUnidadFuncionalSearchComponentRequestDto, DialogUnidadFuncionalSearchComponentResponseDto } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-dialogUnidadFuncionalSearch',
  templateUrl: 'dialogUnidadFuncionalSearch.component.html',
  styleUrls: ['./dialogUnidadFuncionalSearch.component.css']
})

export class DialogUnidadFuncionalSearchComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('gridSelected')
  public gridSelected: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  tipoUnidadList: TipoUnidad[];
  comunidadList: Comunidad[];
  consorcioList: Consorcio[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  isTipoUnidadSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isConsorcioSearching: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags = new TenantFeatureFlags(0, false, false, false, false, false, false, false, false, false, false);

  allowMultipleSelection: boolean = false;
  maxItemSelection: number = 0;
  itemsSeleccionados: UnidadFuncional[] = [];

  public pageSizes: number[];
  public pageSettings: PageSettingsModel;
  public query: Query;

  constructor(
    private dialogRef: MatDialogRef<DialogUnidadFuncionalSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public input: DialogUnidadFuncionalSearchComponentRequestDto,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private service: UnidadFuncionalService,
    private tenantService: TenantService,
    private tipoUnidadService: TipoUnidadService,
    private comunidadService: ComunidadService,
    private consorcioService: ConsorcioService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.allowMultipleSelection = (this.input?.AllowMultipleSelection ?? false);
    this.maxItemSelection = (this.input?.MaxItemSelection ?? 0);

    this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
      this.isValidating = false;
      if (dataTenant != null && dataTenant.Success)
        this.tenantFeatureFlags = dataTenant.Result;
      this.loadView();
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };

    this.setQueryParams();

    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getComunidades();
    this.getConsorcios();
    this.getTiposUnidad();
  }

  getTotalSelectionText() {
    return (this.allowMultipleSelection && this.maxItemSelection > 0 ? "de " + this.maxItemSelection : "");
  }

  getTiposUnidad() {
    var r = new SearchTipoUnidadRequest(null, null, true, "Nombre", null, null, null, true);
    this.isTipoUnidadSearching = true;

    this.tipoUnidadService.search(r).subscribe(data => {
      this.isTipoUnidadSearching = false;
      if (data != null)
        this.tipoUnidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoUnidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getConsorcios() {
    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'Codigo': [null],
      'Numero': [null],
      'TipoUnidadId': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId]
    });

    if (this.input?.Filters != null)
      this.searchForm.patchValue(this.input?.Filters);
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Codigo);

    index = this.query.params.findIndex(obj => obj.key === "Numero");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Numero;
    else
      this.query.addParams("Numero",this.searchForm.value.Numero);

    index = this.query.params.findIndex(obj => obj.key === "TipoUnidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoUnidadId;
    else
      this.query.addParams("TipoUnidadId",this.searchForm.value.TipoUnidadId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = "true".toString();
    else
      this.query.addParams("VerSoloActivos", "true".toString());
  }

  onRowSelected(args: RowSelectEventArgs) {
    if (!this.allowMultipleSelection) {
      const selectedrecords: any[] = this.grid.getSelectedRecords();

      if (selectedrecords != null && selectedrecords.length > 0)
        this.addItem(selectedrecords[0]);
    }
  }

  addItem(item: UnidadFuncional) {
    if (this.itemsSeleccionados == null)
      this.itemsSeleccionados = [];

    if (item != null && item.Id  > 0) {
      var index = this.itemsSeleccionados.findIndex(f => f.Id == item.Id);

      if (index < 0) {
        if (!this.allowMultipleSelection)
          this.itemsSeleccionados = [];
        else {
          if (this.maxItemSelection > 0 && this.itemsSeleccionados.length >= this.maxItemSelection) {
            this.sharedFunctions.showMessage("Llegaste al límite de unidades funcionales que podes seleccionar", "Error");
            return false;
          }
        }

        this.itemsSeleccionados.push(item);
        if (this.gridSelected != null)
          this.gridSelected.refresh();
      }
    }
  }

  removeItem(item: UnidadFuncional) {
    if (this.itemsSeleccionados == null)
      this.itemsSeleccionados = [];

    if (item != null && item.Id  > 0) {
      var index = this.itemsSeleccionados.findIndex(f => f.Id == item.Id);
      if (index >= 0) {
        this.itemsSeleccionados.splice(index, 1);
        if (this.gridSelected != null)
          this.gridSelected.refresh();
      }
    }
  }

  onSelect() {
    if (this.itemsSeleccionados == null || this.itemsSeleccionados.length == 0) {
      this.sharedFunctions.showMessage("Debe seleccionar " + (this.allowMultipleSelection ? "al menos" : "") + " una unidad funcional para continuar", "Error");
      return false;
    }

    this.dialogRef.close(new DialogUnidadFuncionalSearchComponentResponseDto(false, this.itemsSeleccionados));
  }

  onClear() {
    this.itemsSeleccionados = [];
    this.onSearch();
  }

  onCancel() {
    this.dialogRef.close(new DialogUnidadFuncionalSearchComponentResponseDto(true, []));
  }
}
